export const InventoryAdjustmentOptions = [
	{ value: 'Current stock', label: 'Current stock' },
	{ value: 'Safe stock', label: 'Safe Stock' }
];

export const ScannedStockInventoryAdjustOption = [
	{ value: 'Inbound', label: 'Inbound' },
	{ value: 'Outbound', label: 'Outbound' }
];
